import {
    convertToCSV,
    convertToExcel,
} from "../../services/excelDownloadService";
import {exportToPDF} from "../../services/pdfDownloadService";
import React from "react";
import {exportHTMLDocument} from "../../services/HTMLDocumentDownloadService";
import {Tooltip} from "antd";

const Download = ({
                      dataSourceForExcel = [] as any[],
                      dataSource = [] as any[],
                      excelFileTitle,
                      pdfFileTitle,
                      excelPageTitle,
                      grandTotalFor = {},
                  }): any => {
    return (
        <div>
            {dataSource.length === 0 && dataSourceForExcel.length <= 1 ? (<div></div>
            ) : (
                <div style={{display: "flex", alignItems: "center", gap: "5px"}}>

                    <div className="me-4">
                        <span className="fs-9 text-muted fw-bolder pop">Export</span>
                    </div>

                    <div style={{display: "flex", gap: "10px"}}>
                        {dataSourceForExcel.length <= 1 ? (<div></div>
                        ) : (
                            <>
          <span
              className="cursor-pointer"
              onClick={() => {
                  convertToExcel(dataSourceForExcel, excelFileTitle, excelPageTitle);
              }}
          >
          <Tooltip title="Export as Excel Document">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M21.5868 3.30392H13.9893V1.51367L1.5011 3.44117V20.3364L13.9893 22.4874V19.8339H21.5868C21.8169 19.8456 22.0423 19.7656 22.2136 19.6116C22.3849 19.4576 22.4883 19.242 22.5011 19.0119V4.12517C22.4881 3.89527 22.3847 3.67985 22.2134 3.52597C22.0421 3.37209 21.8168 3.29226 21.5868 3.30392ZM21.7068 19.1484H13.9638L13.9511 17.7317H15.8163V16.0817H13.9368L13.9278 15.1067H15.8163V13.4567H13.9136L13.9046 12.4817H15.8163V10.8317H13.8986V9.85667H15.8163V8.20667H13.8986V7.23167H15.8163V5.58167H13.8986V4.08167H21.7068V19.1484Z"
                  fill="#20744A"
              ></path>
              <path
                  d="M16.8663 5.5791H20.1086V7.2291H16.8663V5.5791ZM16.8663 8.20485H20.1086V9.85485H16.8663V8.20485ZM16.8663 10.8306H20.1086V12.4806H16.8663V10.8306ZM16.8663 13.4564H20.1086V15.1064H16.8663V13.4564ZM16.8663 16.0821H20.1086V17.7321H16.8663V16.0821Z"
                  fill="#20744A"
              ></path>
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.76135 8.00433L6.37085 7.91208L7.3826 10.6938L8.5781 7.79733L10.1876 7.70508L8.2331 11.6546L10.1876 15.6138L8.48585 15.4991L7.33685 12.4811L6.1871 15.3843L4.62335 15.2463L6.43985 11.7491L4.76135 8.00433Z"
                  fill="white"
              ></path>
            </svg>
          </Tooltip>
        </span>

                                <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                        convertToCSV(dataSourceForExcel, excelFileTitle, excelPageTitle);
                                    }}
                                >
          <Tooltip title="Export as CSV">
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                  x="0.5"
                  y="0.5"
                  width="29"
                  height="29"
                  rx="1.5"
                  fill="white"
              />
              <path
                  d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                  stroke="#B4DDA9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <rect
                  x="0.5"
                  y="0.5"
                  width="29"
                  height="29"
                  rx="1.5"
                  stroke="#E8E8E8"
              />
              <path
                  d="M9.198 17.338C9.198 16.994 9.268 16.694 9.408 16.438C9.548 16.178 9.742 15.978 9.99 15.838C10.238 15.694 10.522 15.622 10.842 15.622C11.254 15.622 11.594 15.726 11.862 15.934C12.134 16.138 12.316 16.426 12.408 16.798H11.502C11.454 16.654 11.372 16.542 11.256 16.462C11.144 16.378 11.004 16.336 10.836 16.336C10.596 16.336 10.406 16.424 10.266 16.6C10.126 16.772 10.056 17.018 10.056 17.338C10.056 17.654 10.126 17.9 10.266 18.076C10.406 18.248 10.596 18.334 10.836 18.334C11.176 18.334 11.398 18.182 11.502 17.878H12.408C12.316 18.238 12.134 18.524 11.862 18.736C11.59 18.948 11.25 19.054 10.842 19.054C10.522 19.054 10.238 18.984 9.99 18.844C9.742 18.7 9.548 18.5 9.408 18.244C9.268 17.984 9.198 17.682 9.198 17.338ZM14.2954 19.054C14.0234 19.054 13.7794 19.006 13.5634 18.91C13.3474 18.81 13.1754 18.676 13.0474 18.508C12.9234 18.34 12.8554 18.154 12.8434 17.95H13.6894C13.7054 18.078 13.7674 18.184 13.8754 18.268C13.9874 18.352 14.1254 18.394 14.2894 18.394C14.4494 18.394 14.5734 18.362 14.6614 18.298C14.7534 18.234 14.7994 18.152 14.7994 18.052C14.7994 17.944 14.7434 17.864 14.6314 17.812C14.5234 17.756 14.3494 17.696 14.1094 17.632C13.8614 17.572 13.6574 17.51 13.4974 17.446C13.3414 17.382 13.2054 17.284 13.0894 17.152C12.9774 17.02 12.9214 16.842 12.9214 16.618C12.9214 16.434 12.9734 16.266 13.0774 16.114C13.1854 15.962 13.3374 15.842 13.5334 15.754C13.7334 15.666 13.9674 15.622 14.2354 15.622C14.6314 15.622 14.9474 15.722 15.1834 15.922C15.4194 16.118 15.5494 16.384 15.5734 16.72H14.7694C14.7574 16.588 14.7014 16.484 14.6014 16.408C14.5054 16.328 14.3754 16.288 14.2114 16.288C14.0594 16.288 13.9414 16.316 13.8574 16.372C13.7774 16.428 13.7374 16.506 13.7374 16.606C13.7374 16.718 13.7934 16.804 13.9054 16.864C14.0174 16.92 14.1914 16.978 14.4274 17.038C14.6674 17.098 14.8654 17.16 15.0214 17.224C15.1774 17.288 15.3114 17.388 15.4234 17.524C15.5394 17.656 15.5994 17.832 15.6034 18.052C15.6034 18.244 15.5494 18.416 15.4414 18.568C15.3374 18.72 15.1854 18.84 14.9854 18.928C14.7894 19.012 14.5594 19.054 14.2954 19.054ZM17.6789 18.226L18.5189 15.676H19.4129L18.1829 19H17.1629L15.9389 15.676H16.8389L17.6789 18.226Z"
                  fill="#4CC12D"
              />
            </svg>
          </Tooltip>
        </span>
                            </>
                        )}

                        {dataSource.length === 0 ? (<div></div>
                        ) : (
                            <>
                              <span
                                  className="cursor-pointer"
                                  onClick={() => {
                                      exportToPDF(dataSource, pdfFileTitle);
                                  }}
                              >
          <Tooltip title="Export as PDF Document">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M18.0761 1.55371L22.2491 5.90371V22.4457H6.66034V22.4997H22.3023V5.95846L18.0761 1.55371Z"
                  fill="#909090"
              ></path>
              <path
                  d="M18.0244 1.5H6.60712V22.446H22.2491V5.90475L18.0244 1.5Z"
                  fill="#F4F4F4"
              ></path>
              <path
                  d="M6.49233 2.625H1.69983V7.74525H16.7748V2.625H6.49233Z"
                  fill="#7A7B7C"
              ></path>
              <path
                  d="M16.8551 7.65818H1.79736V2.53418H16.8551V7.65818Z"
                  fill="#DD2025"
              ></path>
              <path
                  d="M6.79013 3.40003H5.80988V7.00003H6.58088V5.78578L6.75113 5.79553C6.91655 5.79268 7.08043 5.76305 7.23638 5.70778C7.3731 5.66075 7.49888 5.58651 7.60613 5.48953C7.71525 5.39714 7.80129 5.28055 7.85738 5.14903C7.9326 4.9304 7.95947 4.69805 7.93613 4.46803C7.93144 4.30371 7.90263 4.14097 7.85063 3.98503C7.80328 3.87246 7.73302 3.77098 7.64431 3.68705C7.5556 3.60312 7.45039 3.53857 7.33538 3.49753C7.23593 3.46153 7.13319 3.4354 7.02863 3.41953C6.94944 3.40731 6.86949 3.40079 6.78938 3.40003M6.64763 5.12053H6.58088V4.01053H6.72563C6.78951 4.00592 6.85361 4.01573 6.9132 4.03922C6.97279 4.06272 7.02633 4.09931 7.06988 4.14628C7.16011 4.26704 7.20832 4.41403 7.20713 4.56478C7.20713 4.74928 7.20713 4.91653 7.04063 5.03428C6.92068 5.10025 6.78414 5.1307 6.64763 5.12053ZM9.40088 3.39028C9.31763 3.39028 9.23663 3.39628 9.17963 3.39853L9.00113 3.40303H8.41613V7.00303H9.10463C9.36774 7.01024 9.62971 6.96564 9.87563 6.87178C10.0736 6.79327 10.2488 6.66671 10.3856 6.50353C10.5186 6.33887 10.6141 6.14716 10.6654 5.94178C10.7243 5.70918 10.753 5.46996 10.7509 5.23003C10.7654 4.94665 10.7435 4.66257 10.6856 4.38478C10.6307 4.1803 10.5279 3.99185 10.3856 3.83503C10.274 3.7084 10.1374 3.60626 9.98438 3.53503C9.85296 3.47422 9.71472 3.42939 9.57263 3.40153C9.51612 3.39219 9.45889 3.38793 9.40163 3.38878M9.26513 6.34153H9.19013V4.04353H9.19988C9.35449 4.02574 9.51094 4.05364 9.64988 4.12378C9.75162 4.20502 9.83453 4.30738 9.89288 4.42378C9.95584 4.54628 9.99214 4.68073 9.99938 4.81828C10.0061 4.98328 9.99938 5.11828 9.99938 5.23003C10.0024 5.35876 9.99415 5.4875 9.97463 5.61478C9.95151 5.74545 9.90878 5.87188 9.84788 5.98978C9.77894 6.09939 9.68581 6.19176 9.57563 6.25978C9.48309 6.31963 9.37352 6.34755 9.26363 6.33928M13.0736 3.40303H11.2511V7.00303H12.0221V5.57503H12.9971V4.90603H12.0221V4.07203H13.0721V3.40303"
                  fill="#464648"
              ></path>
              <path
                  d="M16.3369 15.1911C16.3369 15.1911 18.7279 14.7576 18.7279 15.5744C18.7279 16.3911 17.2466 16.0589 16.3369 15.1911ZM14.5691 15.2534C14.1892 15.3373 13.819 15.4602 13.4644 15.6201L13.7644 14.9451C14.0644 14.2701 14.3756 13.3499 14.3756 13.3499C14.7336 13.9524 15.1501 14.5181 15.6191 15.0389C15.2654 15.0916 14.9149 15.1637 14.5691 15.2549V15.2534ZM13.6226 10.3784C13.6226 9.66664 13.8529 9.47239 14.0321 9.47239C14.2114 9.47239 14.4131 9.55864 14.4199 10.1766C14.3615 10.7981 14.2313 11.4106 14.0321 12.0021C13.7592 11.5055 13.618 10.9473 13.6219 10.3806L13.6226 10.3784ZM10.1359 18.2654C9.40236 17.8266 11.6741 16.4759 12.0859 16.4324C12.0836 16.4331 10.9039 18.7244 10.1359 18.2654ZM19.4261 15.6711C19.4186 15.5961 19.3511 14.7659 17.8736 14.8011C17.2578 14.7912 16.6422 14.8346 16.0339 14.9309C15.4446 14.3372 14.9371 13.6675 14.5249 12.9396C14.7846 12.1892 14.9417 11.4071 14.9921 10.6146C14.9704 9.71464 14.7551 9.19864 14.0651 9.20614C13.3751 9.21364 13.2746 9.81739 13.3654 10.7159C13.4543 11.3197 13.6219 11.9092 13.8641 12.4694C13.8641 12.4694 13.5454 13.4616 13.1239 14.4486C12.7024 15.4356 12.4144 15.9531 12.4144 15.9531C11.6814 16.1917 10.9914 16.5462 10.3706 17.0031C9.75261 17.5784 9.50136 18.0201 9.82686 18.4619C10.1074 18.8429 11.0891 18.9291 11.9666 17.7794C12.4329 17.1855 12.8588 16.5611 13.2416 15.9104C13.2416 15.9104 14.5796 15.5436 14.9959 15.4431C15.4121 15.3426 15.9154 15.2631 15.9154 15.2631C15.9154 15.2631 17.1371 16.4924 18.3154 16.4489C19.4936 16.4054 19.4366 15.7446 19.4291 15.6726"
                  fill="#DD2025"
              ></path>
              <path
                  d="M17.9666 1.55762V5.96237H22.1914L17.9666 1.55762Z"
                  fill="#909090"
              ></path>
              <path
                  d="M18.0244 1.5V5.90475H22.2491L18.0244 1.5Z"
                  fill="#F4F4F4"
              ></path>
              <path
                  d="M6.73233 3.34241H5.75208V6.94241H6.52607V5.72891L6.69708 5.73866C6.8625 5.73581 7.02638 5.70618 7.18232 5.65091C7.31904 5.60387 7.44482 5.52962 7.55207 5.43266C7.66038 5.34003 7.74563 5.22345 7.80107 5.09216C7.8763 4.87353 7.90316 4.64119 7.87983 4.41116C7.87514 4.24684 7.84633 4.0841 7.79432 3.92816C7.74698 3.81559 7.67672 3.71411 7.58801 3.63018C7.4993 3.54625 7.39409 3.48171 7.27908 3.44066C7.17917 3.40431 7.07592 3.37793 6.97083 3.36191C6.89164 3.34969 6.81169 3.34318 6.73158 3.34241M6.58982 5.06291H6.52308V3.95291H6.66858C6.73246 3.9483 6.79656 3.95811 6.85615 3.98161C6.91574 4.0051 6.96928 4.04169 7.01283 4.08866C7.10306 4.20942 7.15127 4.35641 7.15007 4.50716C7.15007 4.69166 7.15008 4.85891 6.98358 4.97666C6.86363 5.04263 6.72709 5.07234 6.59058 5.06216M9.34308 3.33266C9.25983 3.33266 9.17883 3.33866 9.12183 3.34091L8.94557 3.34541H8.36057V6.94541H9.04908C9.31219 6.95262 9.57416 6.90803 9.82008 6.81416C10.018 6.73565 10.1933 6.6091 10.3301 6.44591C10.4631 6.28125 10.5586 6.08954 10.6098 5.88416C10.6687 5.65156 10.6975 5.41235 10.6953 5.17241C10.7099 4.88903 10.6879 4.60495 10.6301 4.32716C10.5752 4.12268 10.4723 3.93423 10.3301 3.77741C10.2185 3.65078 10.0819 3.54864 9.92883 3.47741C9.79741 3.4166 9.65917 3.37178 9.51707 3.34391C9.46057 3.33458 9.40334 3.33031 9.34608 3.33116M9.20957 6.28391H9.13458V3.98591H9.14433C9.29894 3.96812 9.45539 3.99602 9.59433 4.06616C9.69607 4.14741 9.77898 4.24976 9.83733 4.36616C9.90029 4.48866 9.93659 4.62311 9.94382 4.76066C9.95057 4.92566 9.94382 5.06066 9.94382 5.17241C9.94688 5.30114 9.9386 5.42989 9.91908 5.55716C9.89596 5.68783 9.85323 5.81426 9.79233 5.93216C9.72339 6.04178 9.63026 6.13414 9.52008 6.20216C9.42754 6.26201 9.31797 6.28993 9.20808 6.28166M13.0158 3.34541H11.1933V6.94541H11.9643V5.51741H12.9393V4.84841H11.9643V4.01441H13.0143V3.34541"
                  fill="white"
              ></path>
            </svg>
          </Tooltip>
        </span>

                                <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                        exportHTMLDocument(dataSource, pdfFileTitle, grandTotalFor);
                                    }}
                                >
          <Tooltip title="Export as HTML Document">
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                  x="0.5"
                  y="0.5"
                  width="29"
                  height="29"
                  rx="1.5"
                  fill="white"
              />
              <path
                  d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                  stroke="#CEB39B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <rect
                  x="0.5"
                  y="0.5"
                  width="29"
                  height="29"
                  rx="1.5"
                  stroke="#E8E8E8"
              />
              <path
                  d="M11.286 15.628C11.538 15.628 11.762 15.684 11.958 15.796C12.154 15.904 12.306 16.066 12.414 16.282C12.526 16.494 12.582 16.75 12.582 17.05V19H11.742V17.164C11.742 16.9 11.676 16.698 11.544 16.558C11.412 16.414 11.232 16.342 11.004 16.342C10.772 16.342 10.588 16.414 10.452 16.558C10.32 16.698 10.254 16.9 10.254 17.164V19H9.414V14.56H10.254V16.09C10.362 15.946 10.506 15.834 10.686 15.754C10.866 15.67 11.066 15.628 11.286 15.628ZM14.3588 16.366V17.974C14.3588 18.086 14.3848 18.168 14.4368 18.22C14.4928 18.268 14.5848 18.292 14.7128 18.292H15.1028V19H14.5748C13.8668 19 13.5128 18.656 13.5128 17.968V16.366H13.1168V15.676H13.5128V14.854H14.3588V15.676H15.1028V16.366H14.3588ZM19.835 15.628C20.243 15.628 20.571 15.754 20.819 16.006C21.071 16.254 21.197 16.602 21.197 17.05V19H20.357V17.164C20.357 16.904 20.291 16.706 20.159 16.57C20.027 16.43 19.847 16.36 19.619 16.36C19.391 16.36 19.209 16.43 19.073 16.57C18.941 16.706 18.875 16.904 18.875 17.164V19H18.035V17.164C18.035 16.904 17.969 16.706 17.837 16.57C17.705 16.43 17.525 16.36 17.297 16.36C17.065 16.36 16.881 16.43 16.745 16.57C16.613 16.706 16.547 16.904 16.547 17.164V19H15.707V15.676H16.547V16.078C16.655 15.938 16.793 15.828 16.961 15.748C17.133 15.668 17.321 15.628 17.525 15.628C17.785 15.628 18.017 15.684 18.221 15.796C18.425 15.904 18.583 16.06 18.695 16.264C18.803 16.072 18.959 15.918 19.163 15.802C19.371 15.686 19.595 15.628 19.835 15.628ZM22.8341 14.56V19H21.9941V14.56H22.8341Z"
                  fill="#F37708"
              />
            </svg>
          </Tooltip>
        </span>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export {Download};
